export const SPORT_LIVE_TV_ROUTE = '/sport-live-tv';

export const SPORT_LIVE_TV_WATCH_ROUTE_NAME = 'WatchSportLiveTv';

export const SPORT_LIVE_TV_POPULAR_LIMIT = 12;

export const SPORT_LIVE_TV_EVENTS_PER_ROW = 12;

export const SPORT_LIVE_TV_CATEGORIES_LIMIT = 50;

export const SPORT_LIVE_TV_TEAMS_LIMIT = 50;

export const SPORT_LIVE_TV_EVENTS_LIMIT = 50;

export const SPORT_LIVE_TV_SEARCH_LIMIT = 20;

export const SPORT_LIVE_TV_CAROUSEL_SETTINGS = {
  itemsToShow: 1.5,
  itemsToScroll: 1,
  snapAlign: 'start',
  transition: 300,
};

export const SPORT_LIVE_TV_CAROUSEL_BREAKPOINTS = {
  700: { itemsToShow: 3, itemsToScroll: 3 },
  1024: { itemsToShow: 5, itemsToScroll: 5 },
};

export const SPORT_LIVE_TV_POSITION_INTERVAL_MS = 15_000;

export const SPORT_LIVE_TV_HIDE_HEADER_DELAY_MS = 3000;

export const SPORT_LIVE_TV_STATUSES = {
  all: 'all',
  live: 'live',
  upcoming: 'upcoming',
};

export const SPORT_LIVE_TV_SORTS = {
  newest: 'newest',
  oldest: 'oldest',
  alphabeticalAsc: 'alphabeticalAsc',
  alphabeticalDesc: 'alphabeticalDesc',
};

export const SPORT_LIVE_TV_FILTER_GROUPS = {
  leagues: 'leagues',
  teams: 'teams',
};

export const SPORT_LIVE_TV_DEFAULT_STATUS = SPORT_LIVE_TV_STATUSES.all;

export const SPORT_LIVE_TV_DEFAULT_SORT = SPORT_LIVE_TV_SORTS.newest;

export const SPORT_LIVE_TV_STATUS_OPTIONS = [
  { value: SPORT_LIVE_TV_STATUSES.all, labelKey: 'allGames' },
  { value: SPORT_LIVE_TV_STATUSES.live, labelKey: 'live' },
  { value: SPORT_LIVE_TV_STATUSES.upcoming, labelKey: 'upcoming' },
];

export const SPORT_LIVE_TV_SORT_OPTIONS = [
  { value: SPORT_LIVE_TV_SORTS.newest, labelKey: 'sortNewest' },
  { value: SPORT_LIVE_TV_SORTS.oldest, labelKey: 'sortOldest' },
  { value: SPORT_LIVE_TV_SORTS.alphabeticalAsc, labelKey: 'sortAlphabeticalAsc' },
  { value: SPORT_LIVE_TV_SORTS.alphabeticalDesc, labelKey: 'sortAlphabeticalDesc' },
];

export const SPORT_LIVE_TV_WATCH_VIEWS = {
  loading: 'loading',
  error: 'error',
  streamError: 'streamError',
  streamPicker: 'streamPicker',
  player: 'player',
};

export const createSportLiveTvEmptySelection = () => ({ leagues: [], teams: [] });
